import { render } from "./MCartWrapper.vue?vue&type=template&id=a78d6f2c&ts=true"
import script from "./MCartWrapper.vue?vue&type=script&lang=ts"
export * from "./MCartWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__